import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import Alert from "react-s-alert";

class CPassModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user_passw : '',
            isLoadingBu : false
        }

        this.toggleModalPass = this.toggleModalPass.bind(this)
        this.handleSubmitChangePass = this.handleSubmitChangePass.bind(this)
        this.handleChangeMod = this.handleChangeMod.bind(this)
    }

    toggleModalPass() {
        this.props.toggleModalPass()
    }

    handleSubmitChangePass() {
        this.setState({ isLoadingBu: true })

        let formData = new FormData();

        formData.append('user_id', this.props.userId)
        formData.append('user_passw', this.state.user_passw)

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        axios.post("/user/edit/pass", formData, config)
            .then(response => {
                const result = response.data;
                if (result.success){
                    Alert.success(result.message);
                    this.setState({ isLoadingBu: false,user_passw : '' })
                    this.toggleModalPass();
                }else{
                    Alert.success(result.message);
                    this.setState({ isLoadingBu: false,user_passw : '' })
                    this.toggleModalPass();
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoadingBu: false,user_passw : '' })
                Alert.error("Gagal terhubung ke server!")
            })
    }

    handleChangeMod(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.toggleModalPass} className="modal-primary">
                <ModalHeader toggle={this.toggleModalPass}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    <div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">
                                Nama
                            </label>
                            <div className="col-md-10">
                                <input
                                    name="userNama"
                                    type="text"
                                    className="form-control"
                                    placeholder="Username untuk login"
                                    disabled="disabled"
                                    onChange={this.handleChangeMod}
                                    value={this.props.userNama} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">
                                Username
                            </label>
                            <div className="col-md-10">
                                <input
                                    name="userUserName"
                                    type="text"
                                    className="form-control"
                                    disabled="disabled"
                                    onChange={this.handleChangeMod}
                                    value={this.props.userUserName} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">
                                Password
                            </label>
                            <div className="col-md-10">
                                <input
                                    name="user_passw"
                                    type="text"
                                    className="form-control"
                                    placeholder="Password (Biarkan kosong jika tidak ingin mengganti)"
                                    disabled={this.props.userUserName === "root@master.com"}
                                    onChange={this.handleChangeMod}
                                    autoComplete="disabled"
                                    value={this.state.user_passw} />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleSubmitChangePass}>{this.state.isLoadingBu ? 'Loading...' : this.props.modalSubmitText}</Button>{' '}
                    <Button color="secondary" onClick={this.toggleModalPass}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

CPassModal.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModalPass: PropTypes.func.isRequired,
    userId: PropTypes.func.userId,
    userNama: PropTypes.func.userNama,
    userUserName: PropTypes.func.userUserName
}

export default CPassModal



// WEBPACK FOOTER //
// ./src/components/CPassModal.js